var render = function render(){var _vm=this,_c=_vm._self._c;return _c('image-cropper-upload',{attrs:{"url":_vm.url},on:{"uploaded":_vm.handleUploaded}})
}
var staticRenderFns = []

export { render, staticRenderFns }